import { Component } from '@angular/core';

@Component({
	selector: 'app-first-login-page',
	templateUrl: './first-login-page.component.html',
	styleUrls: ['./first-login-page.component.scss']
})
export class FirstLoginPageComponent {}
